import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/api";

export default function WhatsAppFab() {
  return (
    <a
      href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(
        "Hi Gold Mind Business, I'd like to discuss my business growth."
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-24 right-6 z-40 flex items-center gap-2 px-4 py-3 rounded-full text-white shadow-[0_14px_36px_rgba(37,211,102,0.45)] transition-transform hover:scale-105"
      style={{ backgroundColor: "#25D366" }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#1EBE5C")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#25D366")}
    >
      <MessageCircle className="h-5 w-5" />
      <span className="text-sm font-semibold hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
